<div class="configuracao-gaiola container-fluid">
  <h3><Strong>Reenvio do ultimo status para SFX</Strong></h3>
  <mat-progress-bar
    color="primary"
    mode="indeterminate"
    [hidden]="!isloading"
  ></mat-progress-bar>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title class="text-center"> SRTS </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form">
        <mat-form-field>
          <mat-label>Cliente:</mat-label>
          <mat-select
            formControlName="clienteId"
            disableOptionCentering="true"
            placeholder="Cliente"
          >
            <mat-option selected value="">Selecione...</mat-option>
            <mat-option *ngFor="let c of listagemCLientes" [value]="c.clienteid">{{
              c.nome
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>NRTS:</mat-label>
          <textarea formControlName="nrts" matInput class="texto"></textarea>
        </mat-form-field>
        <button
          (click)="submit()"
          class="float-right"
          mat-flat-button
          color="primary"
          [ngStyle]="{ margin: '6px 10px 0 0' }"
        >
          Reenviar <i class="fas fa-plus" style="font-size: 12px"></i>
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
